import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategorySection from '@/pages/home/components/CategorySection';
import TopicSection from '@/pages/home/components/TopicSection';
import MovieCard from '@/components/feature/MovieCard';
import { movies, getMoviesByType, getHotMovies } from '@/mocks/movies';

export default function Home() {
  const heroMovies = getHotMovies().slice(0, 5);
  const latestMovies = [...getMoviesByType('movie')].sort((a, b) => b.year - a.year).slice(0, 4);
  const latestTv = [...getMoviesByType('tv')].sort((a, b) => b.year - a.year).slice(0, 4);
  const latestVariety = [...getMoviesByType('variety')].sort((a, b) => b.year - a.year).slice(0, 4);
  const hotMovies = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Seo
        title="菠萝蜜网 - 高清电影电视剧资源大全"
        description="菠萝蜜网汇聚最新电影、电视剧和综艺节目，提供丰富多样的影视内容，助您轻松找到喜爱的影视作品。全面覆盖各类热门影视资源，满足不同观影需求。"
        keywords="菠萝蜜网,影视资源,电影大全,电视剧,综艺节目,影视平台,在线影视,高清影视"
      />
      <Navbar />
      <main className="flex-1">
        <HeroCarousel movies={heroMovies} />

        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14 space-y-12 md:space-y-16">
          <CategorySection title="热门电影" icon="ri-film-line" type="movie" movies={latestMovies} />
          <CategorySection title="热门电视剧" icon="ri-tv-2-line" type="tv" movies={latestTv} />
          <CategorySection title="热门综艺" icon="ri-mic-2-line" type="variety" movies={latestVariety} />

          <section>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-fire-line"></i>
              </div>
              <h2 className="text-lg md:text-xl font-bold text-foreground-900">热门影视推荐</h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
              {hotMovies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} showType />
              ))}
            </div>
          </section>

          <TopicSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}